import { render, staticRenderFns } from "./generate-ppt-dialog.vue?vue&type=template&id=360dff2f&scoped=true"
import script from "./generate-ppt-dialog.vue?vue&type=script&lang=js"
export * from "./generate-ppt-dialog.vue?vue&type=script&lang=js"
import style0 from "./generate-ppt-dialog.vue?vue&type=style&index=0&id=360dff2f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360dff2f",
  null
  
)

export default component.exports